import Cookies from 'cookies-js'
import { isObject, merge } from 'lodash-es'

export default {
  get(key) {
    return Cookies.get(key)
  },

  getJSON(key) {
    const value = this.get(key)

    return value && JSON.parse(value)
  },

  set(key, val, options) {
    if (isObject(val)) {
      return Cookies.set(key, JSON.stringify(val), options)
    }

    return Cookies.set(key, val, options)
  },

  updateJSON(key, val, options) {
    const currentVal = this.getJSON(key) || {}

    return this.set(key, merge(currentVal, val), options)
  },

  expire(key) {
    return Cookies.expire(key)
  },
}
